import type PersonConstituent from '@/types/api/PersonConstituent';

const getFullName = ({ firstName = '', lastName = '' }: PersonConstituent) => {
  const nameParts = [firstName, lastName];

  return nameParts.reduce((fullName, part) => {
    if (part) {
      return fullName?.length ? `${fullName} ${part}` : part;
    }

    return fullName;
  }, '');
};

export default getFullName;
